/* eslint-disable react-refresh/only-export-components */

import { ReactElement } from 'react'
import { IUserViewModel } from '../../types/interfaces'

const Releases: Release[] = [
  {
    name: '2025.12',
    date: '27.08.2025',
    modalHeader: {
      image: '/whatsnew.png',
      title: {
        en: 'New section available!',
        de: 'Neue verfügbare Sektion!',
        fr: 'Nouvelle section disponible !',
        it: 'Nuova sezione disponibile!',
      },
      icon: 'icon-info',
    },
    features: [
      {
        title: {
          en: 'We are pleased to announce that from today it is possible to view the latest Release Notes of Interfleet4U in a dedicated page available in your User menu.',
          de: 'Wir freuen uns, Ihnen ab sofort die neuesten Versionshinweise von Interfleet4U direkt und übersichtlich auf einer eigenen Seite im Benutzermenü präsentieren zu dürfen.',
          fr: 'Nous sommes heureux d’annoncer qu’à partir d’aujourd’hui, il est possible de consulter les dernières Notes de version d’Interfleet4U dans une page dédiée disponible dans votre menu Utilisateur.',
          it: 'Siamo lieti di annunciare che da oggi è possibile consultare le ultime Note di Rilascio di Interfleet4U in una pagina dedicata disponibile nel tuo menu Utente.',
        },
        body: <img src="/new-content-aug25_2608.png" style={{ margin: '20px auto', display: 'block' }} />,
        visibility: [{ role: 'customer' }],
      },
    ],
  },
  {
    name: '2025.11',
    date: '14.08.2025',
    modalHeader: {
      image: '/whatsnew.png',
      title: {
        en: 'New functionality available!',
        de: 'Neue Funktionalität verfügbar!',
        fr: 'Nouvelle fonctionnalité disponible !',
        it: 'Nuova funzionalità disponibile!',
      },
    },
    features: [
      {
        title: {
          en: 'New status for your replacement orders management',
          de: 'Neuer Status für die Verwaltung Ihrer Ersatzbestellungen',
          fr: 'Nouveau statut pour la gestion de vos commandes de remplacement',
          it: 'Nuovo stato per la gestione dei tuoi ordini di sostituzione',
        },
        body: <img src="/new-content-july25_1b.png" style={{ maxWidth: '70%', margin: '0 auto', display: 'block' }} />,
        visibility: [{ role: 'customer' }],
      },
      {
        title: {
          en: 'Easily manage your replacement orders with the new icons and filters. Be alerted if no replacement is placed within 6 months from the expiration date.',
          de: 'Verwalten Sie Ihre Ersatzbestellungen ganz einfach mit den neuen Symbolen und Filtern. Werden Sie benachrichtigt, wenn innerhalb von 6 Monaten nach dem Ablaufdatum keine Ersatzbestellung erfolgt.',
          fr: 'Gérez facilement vos commandes de remplacement grâce aux nouveaux icônes et filtres. Recevez une alerte si aucun remplacement n’est effectué dans les 6 mois suivant la date d’expiration.',
          it: 'Gestisci facilmente i tuoi ordini di restituzione grazie a nuove icone e filtri. Ricevi un avviso se non viene inserito un ordine di restituzione entro 6 mesi dalla data di scadenza.',
        },
        body: <img src="/new-content-july25_1.png" style={{ margin: '0 auto', display: 'block' }} />,
        visibility: [{ role: 'customer' }],
      },
      {
        title: {
          en: 'The ability to request support for a specific contract',
          de: 'Möglichkeit, Unterstützung für einen bestimmten Vertrag anzufordern.',
          fr: 'Possibilité de demander de l’assistance pour un contrat spécifique.',
          it: 'Possibilità di richiedere supporto per uno specifico contratto.',
        },
        body: <img src="/new-content-july25_2.png" style={{ margin: '0 auto', display: 'block' }} />,
        visibility: [{ role: 'customer' }],
      },
    ],
  },
]

export interface Release {
  name: string
  date: string
  modalHeader?: { image?: string; title?: Record<'en' | 'de' | 'fr' | 'it', string>; icon?: string }
  features: Feature[]
}

export interface Feature {
  title: Record<'en' | 'de' | 'fr' | 'it', string>
  body: ReactElement
  visibility: ({ role: 'internal' | 'customer' } | { tag: string })[]
}

export function GetFeatureVisible(f: Feature, user?: IUserViewModel | null) {
  return (
    user?.isAdmin ||
    !f.visibility ||
    f.visibility?.some((v) => 'tag' in v && user?.tags?.some((t) => t.toLowerCase() === v.tag.toLowerCase())) ||
    f.visibility?.some((v) => 'role' in v && v.role === 'internal' && user?.isInternalUser) ||
    f.visibility?.some((v) => 'role' in v && v.role === 'customer')
  )
}

export function GetReleaseItemOwners(item: Release | Feature) {
  const features = 'features' in item ? item.features : [item]
  return {
    internal: features.some((f) => f.visibility.some((v) => 'role' in v && v.role === 'internal')),
    customer:
      features.some((f) => f.visibility.some((v) => 'role' in v && v.role === 'customer')) ||
      features.some((f) => f.visibility.some((v) => 'tag' in v)),
    interfleetPro: features.some((f) => f.visibility.some((v) => 'tag' in v && v.tag.toLowerCase() === '4upro')),
  }
}

export function GetUserReleases(user?: IUserViewModel | null): Release[] {
  return Releases.map((r) => ({
    ...r,
    features: r.features.filter((f) => GetFeatureVisible(f, user)),
  }))
    .filter((r) => r.features.length)
    .sort((a, b) => {
      const aStr = a.date.replace(/(\d{2}).(\d{2}).(\d{4})/, '$3-$2-$1')
      const bStr = b.date.replace(/(\d{2}).(\d{2}).(\d{4})/, '$3-$2-$1')
      const aDate = new Date(aStr)
      const bDate = new Date(bStr)
      const aTime = aDate.getTime ? aDate.getTime() : 0
      const bTime = bDate.getTime ? bDate.getTime() : 0
      return bTime - aTime
    })
}
